// External packages
import { z } from 'zod';

export const exhibitsCreateSchema = z.object({
  name: z.string({ message: 'Dodajte naziv' }),
  translations: z
    .array(
      z.object({
        languageCode: z.string(),
        title: z.string({ message: 'Dodajte naslov' }),
        description: z.string({ message: 'Dodajte opis' }),
        shortDescription: z.string().optional(),
        videoIds: z.string().array().optional(),
        audioIds: z.string().array().optional(),
      })
    )
    .min(1, { message: 'Dodajte prijevode' }),
  imageIds: z.string().array().optional(),
  placeId: z.string({ message: 'Odaberite sobu' }),
  position: z.object(
    {
      x: z.number({ message: 'Odaberite poziciju' }),
      y: z.number({ message: 'Odaberite poziciju' }),
    },
    {
      message: 'Odaberite poziciju',
    }
  ),
});
